module.exports = __webpack_public_path__ + "img/the-netherlands-cerebrovascular-disease-male.3cd51854.png";